const INITIAL_STATE = {
  chats: [],
  newMessages: false
};

export default function activeChatInternal(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@HANDLE_INFOS_USER': {
      let auxChat = state.chats;
      if (state.chats.length === 0) {
        auxChat.push(
          Object.assign(action.infos, {
            active: true
          })
        );
      } else {
        let isExist = state.chats.every(
          (item) => item.login !== action.infos.login
        );
        if (isExist && state.chats.length <= 2) {
          auxChat.push(
            Object.assign(action.infos, {
              active: true
            })
          );
        }
        if (isExist && auxChat.length === 3) {
          auxChat.pop();
          auxChat.push(
            Object.assign(action.infos, {
              active: true
            })
          );
        }
      }
      return {
        chats: [...auxChat],
        newMessages: state.newMessages
      };
    }
    case '@ACTIVE_CONVERSATION': {
      let auxChat = state.chats;

      let isExist = state.chats.findIndex(
        (item) => item.login === action.infos.login
      );
      if (isExist != -1) {
        auxChat[isExist].active = action.boll;
      }

      return {
        chats: [...auxChat],
        newMessages: state.newMessages
      };
    }
    case '@ADD_MESSAGE': {
      let stateAux = [...state.chats];
      if (action.isGroupMessage) {
        stateAux.forEach((item) => {
          if (item.login === action.id) {
            if (!item.messages) item.messages = [];

            const now = new Date().toISOString();

            if (typeof action.messages === 'string') {
              item.messages.push({
                content: action.messages,
                sender: action.sender,
                createdAt: now,
                globalStatus: 'sent',
                statusByUser: [],
                id: action.mensagemId
              });
            } else if (typeof action.messages === 'object') {
              item.messages.push(action.messages);
            }
          }
        });
      } else if (action.isSocketUpdate) {
        stateAux.forEach((item) => {
          if (item.login === action.id) {
            if (!item.messages) item.messages = [];

            const now = new Date().toISOString();

            if (typeof action.messages === 'string') {
              item.messages.push({
                content: action.messages,
                sender: action.sender,
                createdAt: now,
                status: { situation: 'sent' },
                id: action.mensagemId
              });
            } else if (typeof action.messages === 'object') {
              item.messages.push(action.messages);
            }
          }
        });
      } else {
        stateAux.forEach((item) => {
          if (item.id === action.id) {
            item.messages = action.messages;
          }
        });
      }

      return {
        chats: [...stateAux],
        newMessages: state.newMessages
      };
    }
    case '@REMOVE_CHAT_SPECIFIC': {
      let stateAux = [...state.chats];
      let removedItem = stateAux.findIndex(
        (item) => item.login === action.data
      );

      stateAux.splice(removedItem, 1);

      return {
        chats: [...stateAux],
        newMessages: state.newMessages
      };
    }
    case '@WATCH_NEW_MESSAGE':
      return {
        chats: [...state.chats],
        newMessages: action.newMessages
      };
    case '@UPDATE_MESSAGE_STATUS': {
      let stateAux = [...state.chats];

      stateAux.forEach((chat) => {
        if (chat.id === action.conversationId) {
          const messageIndex = chat.messages.findIndex(
            (msg) => msg.id === action.messageId
          );
          if (messageIndex !== -1) {
            chat.messages[messageIndex].status = action.newStatus;
          }
        }
      });

      return {
        chats: [...stateAux],
        newMessages: state.newMessages
      };
    }
    case '@UPDATE_MESSAGE_GROUP_STATUS': {
      let stateAux = [...state.chats];
      stateAux.forEach((chat) => {
        if (chat.id === action.groupId) {
          const messageIndex = chat.messages.findIndex(
            (msg) => msg.id === action.messageId
          );
          if (messageIndex !== -1) {
            chat.messages[messageIndex].statusByUser = action.statusByUser;
            chat.messages[messageIndex].globalStatus = action.globalStatus;
          }
        }
      });
      return {
        chats: [...stateAux],
        newMessages: state.newMessages
      };
    }
    default:
      return state;
  }
}
